
import { ApplicationUserModel, ScrapCauseModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { scrapCausesStore } from '@/libs/scrap-causes/+state/store';

@Component({})
export default class ScrapCauseDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    scrapCause: ScrapCauseModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.scrapCause?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadScrapCause()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        reject(e);
                    });
            });
        } else {
            this.scrapCause = {
                id: Guid.EmptyGuid(),
                name: null,
            } as ScrapCauseModel;
            return new Promise((resolve) => resolve(null));
        }
    }

    private loadScrapCause() {
        return new Promise((resolve, reject) => {
            scrapCausesStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(scrapCausesStore, CrudReponse.Get)
                .then((e) => {
                    this.scrapCause = e;
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const scrapCause = { ...this.scrapCause } as ScrapCauseModel;
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                scrapCausesStore.dispatch(CrudAction.Create, { item: scrapCause });
                this.subscribe(scrapCausesStore, CrudReponse.Create)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                scrapCausesStore.dispatch(CrudAction.Update, { item: scrapCause });
                this.subscribe(scrapCausesStore, CrudReponse.Update)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteScrapCause() {
        this.deleting = true;
        scrapCausesStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(scrapCausesStore, CrudReponse.Delete)
            .then(() => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch(() => {
                this.deleting = false;
            });
    }
}
